'use client';

import { RefreshCwIcon, ShoppingCartIcon } from 'lucide-react';
import Link from 'next/link';
import { Tooltipper } from '~/components/common/tooltipper';
import { Badge } from '~/components/ui/badge';
import { Button } from '~/components/ui/button';
import { useBasket } from '~/context/basket-context';
import { cn } from '~/lib/utils';

export function SiteHeaderBasket() {
  const { basket, error, isProcessing, isInitialLoading } = useBasket();

  const getBasketCount = () => {
    if (error) return '!';
    if (!basket?.itemCount) return null;
    if (basket?.itemCount > 99) return '99+';
    return basket?.itemCount;
  };

  const basketCount = getBasketCount();

  const showBasketCounter = Boolean(basket?.itemCount) || isProcessing;

  const getTooltipContent = () => {
    if (error) {
      return 'Error loading basket';
    }

    if (isProcessing) {
      return 'Loading basket...';
    }
    return `Basket - ${basket?.itemCount} item${
      basket?.itemCount !== 1 ? 's' : ''
    }`;
  };

  const showLoader = isProcessing || isInitialLoading;

  return (
    <Tooltipper content={getTooltipContent()}>
      <Button
        asChild
        variant="ghost"
        size="icon"
        title="Basket"
        className="group relative"
        data-testid="site-header-basket"
      >
        <Link href={'/basket'}>
          <Badge
            data-testid="site-header-basket-counter"
            variant="custom"
            className={cn(
              'absolute -right-1 -top-1 h-[1.625rem] w-[1.625rem] origin-center transform-gpu items-center justify-center rounded-full bg-[var(--site-header-basket-counter-background)] p-0 text-center text-[var(--site-header-basket-counter-foreground)] transition duration-200 ease-in-out',
              showBasketCounter || error
                ? 'scale-1 group-focus-visible::scale-125 group-hover:scale-125'
                : 'scale-0',
              error && !showLoader && 'bg-destructive text-white',
            )}
          >
            {showLoader ? (
              <RefreshCwIcon className="relative size-3.5 origin-center animate-spin" />
            ) : (
              basketCount
            )}
          </Badge>

          <ShoppingCartIcon />
        </Link>
      </Button>
    </Tooltipper>
  );
}
